import i18n from '@/lib/i18n/config';

import type {AuthorityType} from '@sollapay/enums';

/** Translated authority display name — shared by every payout table/export that renders one. */
export function resolveAuthorityDisplayName(authorityType: AuthorityType): string {
  return i18n.t(`authorities:${authorityType}.label`);
}
